module.exports = __webpack_public_path__ + "img/openGroup.08bfddb0.svg";